import { useCallback } from 'react';
import { globalAttributes } from '../global-attributes';

export function useGetAgencyType(agencyTypeGlobalAttrId?: number) {
    return useCallback(() => {
        const { FIRE, EMS } = globalAttributes.agencyTypeGlobal;

        switch (agencyTypeGlobalAttrId) {
            case FIRE:
                return 'fire';
            case EMS:
                return 'ems';
            default:
                return 'police';
        }
    }, [agencyTypeGlobalAttrId]);
}
